import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

export const shortcutsSmartLinksQuery: GraphQLTaggedNode = graphql`
	query shortcutsSmartLinksQuery($spaceKey: String!, $cloudId: ID!) {
		confluence_shortcutSmartLinksBySpaceKey(spaceKey: $spaceKey, cloudId: $cloudId) {
			nodes {
				id
				position
				styleClass
				url
				title
				customTitle
				emojiTitle
				canView
				resolved
				product
				subType
				resourceType
				iconUrl
			}
		}
	}
`;
